<template>
  <b-container>
    <b-row>
      <b-col cols="12">
        <b-row v-if="!toolToAdd" cols="12">
          <b-col
            class="col-xl-3 col-lg-4"
            v-for="(tool, index) in $store.getters['tools/listTools']"
            :key="index"
          >
            <tool-shop-tool
              @addtool="handleGetTool"
              :isNew="tool.isNew"
              :isFavorite="tool.isFavorite"
              :image="tool.imgURL"
              :name="tool.name"
              :price="tool.price"
              :oldPrice="tool.oldPrice"
              :tool="tool"
              :disable="focus && checkIsToolExistedOn_focus(tool.toolId)"
            />
          </b-col>
        </b-row>
        <b-container
          class="d-flex align-items-center"
          style="flex-direction: column"
          v-else-if="toolToAdd"
          cols="12"
        >
          <b-row class="mb-4">
            <img :src="toolToAdd.imgURL" style="height: 143px; width: auto" />
          </b-row>
          <b-row class="mb-4" style="width: 60%">
            <!-- <label for="toolName"></label> -->
            <b-input
              v-model="toolName"
              id="toolName"
              placeholder="Enter custom name.."
            />
          </b-row>
          <b-row class="mb-4">
            <b-button :disabled="!toolName" @click="handleAddBtn">
              Add
            </b-button>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import ToolShopTool from "./toolShopTool";
// import tools from "./datatools.json";
// import categories from "./datacats.json";
export default {
  name: "tool-shop",
  components: {
    ToolShopTool
  },
  props: {
    focus: {
      type: Object
    }
  },
  methods: {
    handleSignUpClick(e) {},
    handleGoogleSignInClick(e) {},
    handleGetTool(e) {
      this.toolToAdd = e;
      if (e.name !== "Standard") {
        this.toolName = e.name;
      }
    },
    handleAddBtn() {
      let uid = this.checkIsToolOnDb();
      let toolArr = this.toolName.split(",");
      let {
        _created_at,
        description,
        imgURL,
        name,
        toolId,
        toolRef
      } = this.toolToAdd;
      let tooldetail = {};
      if (_created_at) tooldetail._created_at = _created_at;
      if (description) tooldetail.description = description;
      if (imgURL) tooldetail.imgURL = imgURL;
      if (name) tooldetail.name = name;
      if (toolId) tooldetail.toolId = toolId;
      if (toolRef) tooldetail.toolRef = toolRef.path;
      let tool = {
        _created_at: new Date(),
        text: toolArr[0],
        subText: toolArr.length > 1 ? toolArr[1] : "",
        uid: uid > -1 ? uid : undefined,
        tooldetail: tooldetail
      };
      // this.$store.dispatch('user/addTools', {tools: [tool]})
      // .then(addedTool => {
      this.$emit("addtool", tool);
      // })
    },
    checkIsToolOnDb() {
      let existingTools = this.$store.getters["user/listTools"].map(
        el => el.text
      );
      if (existingTools.includes(this.toolName)) {
        return this.$store.getters["user/listTools"][
          existingTools.indexOf(this.toolName)
        ].uid;
      } else {
        return false;
      }
    },
    checkIsToolExistedOn_focus(toolId) {
      let existingTools = this.$store.getters["user/listTools"];
      let listToolUidOnFocus = this.focus.tools.map(el => el.tools_id);
      let listToolToolIds = this.focus.tools.map(
        el => el.tooldetail && el.tooldetail.toolId
      );
      let focusTools = existingTools.filter(el =>
        listToolUidOnFocus.includes(el.uid)
      );
      let focusToolsListUids = focusTools.map(el => el.tooldetail.toolId);
      if (
        focusToolsListUids.includes(toolId) ||
        listToolToolIds.includes(toolId)
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function() {
    return {
      // tools,
      // categories,
      toolToAdd: null,
      toolName: ""
    };
  },
  mounted() {
    this.$store.dispatch("tools/getListTools");
  }
};
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
